import { render, staticRenderFns } from "./TrickyWords.vue?vue&type=template&id=6f147696&scoped=true&"
import script from "./TrickyWords.vue?vue&type=script&lang=js&"
export * from "./TrickyWords.vue?vue&type=script&lang=js&"
import style0 from "./TrickyWords.vue?vue&type=style&index=0&id=6f147696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f147696",
  null
  
)

export default component.exports